import { useQuery } from "@tanstack/react-query";
import { fetchAttachments, FetchAttachmentsPayload } from "PFCore/services/attachments/fetch_attachments";

import { attachmentsKeys } from "./query_keys";

export const useAttachments = ({ targetType, targetId }: FetchAttachmentsPayload) => {
  const queryKey = attachmentsKeys.list(targetType, targetId);

  return useQuery(queryKey, () => fetchAttachments({ targetType, targetId }));
};
